import React, { useEffect, useRef, useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo2/barriocalles.png";
import Imagen1_1 from "../../../images/modulo2/barriotext.png";
import Imagen2 from "../../../images/modulo2/casa.png";
import Imagen3 from "../../../images/modulo2/bomberos.png";
import Imagen4 from "../../../images/modulo2/libro.png";
import Imagen5 from "../../../images/modulo2/arbol.png";
import Imagen6 from "../../../images/modulo2/hospital.png";
import Imagen7 from "../../../images/modulo2/comisaria.png";
import Imagen8 from "../../../images/modulo2/correo.png";
import Imagen9 from "../../../images/modulo2/dinero.png";
import Imagen10 from "../../../images/modulo2/pistagris.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faSignLanguage,
  faPen,
  faEraser,
} from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../../routes/Module2";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import { ReactSketchCanvas } from "react-sketch-canvas";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo2/Actividad 7.mp3";

const styles = {
  border: "1px solid #9c9c9c",
  borderRadius: "0",
  height: "600px",
  background: `url(${Imagen1})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain'
};

const Actividad7 = () => {
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo2.content[0];
  const infoAct = modulo2.content[0].activities[6];
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title:
        modulo2.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo2.content[0].activities[7].name}`,
    linkNext: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[7].path}`,
    titlePrev: `${modulo2.content[0].activities[5].name}`,
    linkPrev: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title} - ${infoAct.name}`,
    name: modulo2.title
  };

  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo2.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">Actividad 7</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Los planos nos ayudan a ubicarnos en el espacio. Todos los planos
          tienen una leyenda que nos sirve para entender los símbolos
          utilizados.
        </li>
        <li>
          Lee las indicaciones y con el lápiz marca el camino que debe seguir Emilia para
          llegar a su escuela.
        </li>
      </ul>
      <img src={Imagen1_1} className="img-fluid mb-5" alt="Casa" />
      <ReactSketchCanvas
        ref={canvasEl}
        style={styles}
        width="600"
        height="100%"
        strokeWidth={4}
        strokeColor="red"
      />
      <div className="d-flex mt-1 justify-content-end w-100">
        <button
          onClick={activateEraser}
          className={`btn btn-green me-1 ${eraseMode ? "active" : "inactive"}`}
        >
          Borrador <FontAwesomeIcon icon={faEraser} />
        </button>
        <button
          onClick={activatePen}
          className={`btn btn-green me-1 ${penMode ? "active" : "inactive"}`}
        >
          Lapiz <FontAwesomeIcon icon={faPen} />
        </button>
      </div>

      <div className="row mt-1 align-items-center">
        <div className="col-lg-8 col-md-12 col-xs-12">
          <p>
            <strong>Leyenda:</strong>
          </p>
          <Card>
            <div className="row">
              <div className="col-md-4 col-6 d-flex align-items-center">
                Viviendas <img src={Imagen2} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Bomberos <img src={Imagen3} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Escuela <img src={Imagen4} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Parque <img src={Imagen5} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Posta <img src={Imagen6} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Comisaría <img src={Imagen7} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Correo <img src={Imagen8} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Banco <img src={Imagen9} className="img-xs" alt="Casa" />
              </div>
              <div className="col-md-4 col-6 d-flex align-items-center">
                Pista <img src={Imagen10} className="img-xs" alt="Casa" />
              </div>
            </div>
          </Card>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Explique que un plano es un dibujo que representa un lugar visto desde
          arriba y sirve para orientarnos. Lea las indicaciones. Explique que
          hay distintas maneras de llegar a la escuela de Emilia pero que
          deberán seguir las indicaciones dadas. Ayude a resolver la actividad y
          luego conversen sobre el camino seguido y qué otras opciones hay para
          llegar a la escuela.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
